/**
 * Earth-tone Tailwind class fragments for public job site chrome (TEC-382).
 * Uses semantic colours from `styles/jc-public-theme.css` (`bg-jc-*`, `text-jc-*`, …).
 */

export const CORE_HEADER_STICKY =
  'bg-jc-surface border-b border-jc-border sticky top-0 z-40';

export const CORE_HEADER_STICKY_SRP =
  'bg-jc-surface border-b border-jc-border sticky top-0 z-[45]';

export const CORE_NAV_ROW_BORDER = 'border-b border-jc-border';

/** Inactive nav / ghost control */
export const CORE_NAV_LINK =
  'px-2 py-2 rounded-lg text-sm font-medium whitespace-nowrap text-jc-ink-secondary hover:bg-jc-elevated hover:text-jc-ink transition-colors';

export const CORE_LOGO_TEXT = 'font-bold text-jc-ink';

export const CORE_CONTROL_GHOST =
  'text-sm font-medium text-jc-ink-secondary bg-jc-surface/70 border border-jc-border hover:bg-jc-elevated hover:text-jc-ink transition-colors';

export const CORE_MENU_SURFACE =
  'bg-jc-surface rounded-lg shadow-lg dark:shadow-none border border-jc-border';

export const CORE_MENU_ITEM = 'text-jc-ink-secondary hover:bg-jc-elevated hover:text-jc-ink';

export const CORE_MENU_ITEM_ACTIVE =
  'bg-jc-accent-muted text-jc-accent font-medium';

/**
 * Language selector: FI/SV/EN pills. Matches the homepage's `.lp-nav-lang` / `.lp-lang-pill`
 * look (rounded-full track, active pill on a raised card) — the one canonical selector style;
 * `landing.css` keeps its own copy for the prerendered landing nav.
 */
export const CORE_LANG_SEGMENT_CONTAINER =
  'items-center gap-0.5 rounded-full border border-jc-border bg-jc-elevated p-[3px]';

export const CORE_LANG_SEGMENT_ITEM =
  'px-2 py-1 rounded-full text-[11px] font-bold uppercase transition-colors';

export const CORE_LANG_SEGMENT_ACTIVE = 'bg-jc-surface text-jc-ink shadow-sm';

export const CORE_LANG_SEGMENT_INACTIVE =
  'text-jc-ink-secondary hover:text-jc-ink';

/** Filter category chip colours — match `styles/jc-public-theme.css` filter tokens */
export const FILTER_CAT_LOCATION =
  'bg-jc-filter-location-bg text-jc-filter-location-text border border-jc-filter-location-border';

export const FILTER_CAT_SALARY =
  'bg-jc-filter-salary-bg text-jc-filter-salary-text border border-jc-filter-salary-border';

export const FILTER_CAT_COMPANY =
  'bg-jc-filter-company-bg text-jc-filter-company-text border border-jc-filter-company-border';

export const FILTER_CAT_JOB =
  'bg-jc-filter-job-bg text-jc-filter-job-text border border-jc-filter-job-border';
